// Material
import { Skeleton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
// Logic
import { useHall } from '$logic/hall/react-hook'
// Localization
import { useSubscription } from '$logic/subscription/react-hook'
import { toLocale } from '$func/text'
import { t } from '$i18n'

const StyledTypography = styled(Typography)`
  margin-right: 4px;
  display: contents;
`

interface Props {
  hallId: string
}

export function HallStatus({ hallId }: Props) {
  const { entity: hall, loading } = useHall(hallId)
  const { entity: subscription } = useSubscription(hallId)

  if (loading || !hall) return <Skeleton variant="text" />

  const status = hall.public
    ? subscription
      ? `${hall.identifier}@`
      : `${toLocale(hall.membersCount)} ${t('profile.hall.member')} - ${
          hall.identifier
        }@`
    : t('profile.hall.options.type.private')

  return (
    <StyledTypography variant="caption1" noWrap sx={{ color: 'gray' }}>
      {status}
    </StyledTypography>
  )
}
